<div class="page-content-container">
  <!-- OLD LAYOUT (flag OFF) -->
  @if (!useAzureEarlyClassificationUI) {
    <div class="top-header">
      <app-navigation-stepper
        [steps]="navigationSteps"
        [currentStepIndex]="0"
        [enforceLinearProgression]="true"
      ></app-navigation-stepper>
      <div class="action-container">
        <button class="btn btn-outline-secondary" type="button" (click)="exitClicked.emit()">
          <span class="size">Cancel</span>
        </button>
        <div class="btn-separator">|</div>
        <button class="btn btn-primary" type="button" (click)="nextClicked.emit()">
          <span class="size">Next</span>
        </button>
      </div>
    </div>
    <app-table-drawing-page
      [allowOnlyOneBox]="true"
      [pageImages]="documentFile?.pageImages"
      [currentBoxesByPage]="currentBoxesByPage"
      (boxesChanged)="boxesChanged($event)"
    ></app-table-drawing-page>
  }

    <!-- NEW LAYOUT (flag ON) -->
    <ng-container *ngIf="useAzureEarlyClassificationUI">
        <div class="top-header">
            <app-navigation-stepper
                [steps]="navigationSteps"
                [currentStepIndex]="0"
                [enforceLinearProgression]="true"
            ></app-navigation-stepper>
            <div class="action-container">
                <button class="btn btn-outline-secondary" type="button" (click)="exitClicked.emit()">
                    <span class="size">Cancel</span>
                </button>
                <div class="btn-separator">|</div>
                <button class="btn btn-primary" type="button" (click)="nextClicked.emit()">
                    <span class="size">Next</span>
                </button>
            </div>
        </div>

        <div class="main-wrapper redesigned">
            <!-- Left: Document view (thumbnails + viewer) -->
            <div class="document-view-left">
                <!-- Unified document view header -->
                <div class="document-view-header">
                    <div class="header-left-controls">
                        <app-pdf-search
                            [searchText]="searchText"
                            [searchPerformed]="searchPerformed"
                            [searchLoading]="searchLoading"
                            [currentMatchNumber]="currentMatchNumber"
                            [totalMatches]="totalMatches"
                            [disabled]="!documentFile?.id"
                            [searchError]="searchError"
                            (searchTextChange)="onSearchTextChange($event)"
                            (searchSubmit)="onSearchSubmit()"
                            (goToPrevious)="goToPreviousMatch()"
                            (goToNext)="goToNextMatch()"
                            (clearSearch)="clearSearch()"
                        ></app-pdf-search>
                    </div>
                    <div class="header-right-controls">
                        <div class="pagination-controls">
                            <span class="page-label">Page</span>
                            <input
                                type="number"
                                class="page-number-input"
                                [value]="activePageTrueIndex + 1"
                                min="1"
                                [max]="documentFile?.pageImages?.length || 1"
                                (change)="goToPage($event)"
                                (keydown.enter)="goToPage($event)"
                            />
                            <span class="page-total">of {{ documentFile?.pageImages?.length || 0 }}</span>
                            <div class="page-nav-stack">
                                <button class="btn-page-nav" (click)="goToPrevPage()" [disabled]="activePageTrueIndex === 0">
                                    <i class="fas fa-arrow-up"></i>
                                </button>
                                <button class="btn-page-nav" (click)="goToNextPage()" [disabled]="activePageTrueIndex >= (documentFile?.pageImages?.length || 1) - 1">
                                    <i class="fas fa-arrow-down"></i>
                                </button>
                            </div>
                        </div>
                        <div class="zoom-controls">
                            <span class="zoom-percentage">{{ mathFloor(imgScale * 100) }}%</span>
                            <i class="fas fa-search-plus hover icon" (click)="zoomIn()"></i>
                            <i class="fas fa-search-minus hover" (click)="zoomOut()"></i>
                        </div>
                    </div>
                </div>

                <!-- Content area: thumbnails + viewer side by side -->
                <div class="document-view-content">
                    <!-- Thumbnail sidebar -->
                    <div class="thumbnail-sidebar">
                        <div class="thumbnail-sidebar-body" appImgIntersectionObxList>
                            <div *ngFor="let page of filteredPagesToShow; trackBy: trackByPageIndex"
                                 class="sidebar-thumbnail-item fs-block fs-exclude"
                                 appImgIntersectionObx
                                 #intersection="intersection"
                                 #sidebarThumbnail
                                 [class.active]="page.pageIndex === activePageTrueIndex"
                            >
                                <app-document-thumbnail
                                    *ngIf="intersection.hasIntersected; else imagePlaceholder"
                                    [imageWidth]="150"
                                    [sourceImageUrl]="page.thumbnail.signedUrl"
                                    [page]="page"
                                    [boxes]="currentBoxesByPage[page.pageIndex]"
                                    [hidePagePrefix]="true"
                                    (onImageClickEvent)="activatePageRedesigned($event)"
                                ></app-document-thumbnail>
                                <ng-template #imagePlaceholder>
                                    <div class="sidebar-image-placeholder">
                                        ...
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>

                    <!-- Document viewer -->
                    <div class="document-viewer-pane">
                        <div class="viewer-body" id="redesigned-box-drawer-scroll-container">
                            <div class="box-drawer-with-highlights" *ngIf="getCurrentPageImage()?.normalRes?.signedUrl">
                                <app-box-drawer
                                    id="selected-page-image"
                                    [boxes]="currentBoxesByPage[activePageTrueIndex]"
                                    [sourceImageUrl]="getCurrentPageImage().normalRes.signedUrl"
                                    [allowEdit]="true"
                                    [inputImageWidth]="boxDrawingWidth * imgScale"
                                    [onlyAllowOneBox]="true"
                                    (boxesChanged)="boxesChangedRedesigned({boxes: $event, activePageIndex: activePageTrueIndex})"
                                    scrollingContainerElementId="redesigned-box-drawer-scroll-container"
                                ></app-box-drawer>
                                <div class="search-highlight-overlay"
                                     *ngIf="searchPerformed && getDisplayHighlightsForCurrentPage().length > 0">
                                    <div class="text-highlight"
                                         *ngFor="let h of getDisplayHighlightsForCurrentPage(); trackBy: trackHighlightById"
                                         [attr.data-highlight-id]="h.id"
                                         [class.active]="h.id === activeHighlightId"
                                         [style.left.px]="h.left"
                                         [style.top.px]="h.top"
                                         [style.width.px]="h.width"
                                         [style.height.px]="h.height"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right pane: Summary panel -->
            <div class="summary-pane">
                <app-merge-table-summary-panel
                    [capturedTables]="capturedMergeTables"
                    [selectedTable]="selectedMergeTable"
                    [activePageIndex]="activePageTrueIndex"
                    (viewTable)="onViewTableFromSummary($event)"
                ></app-merge-table-summary-panel>
            </div>
        </div>
    </ng-container>
</div>
